import { createAsyncThunk } from '@reduxjs/toolkit';

import callApi from '../../../service/callApi';
import { enqueueSnackbar } from '../../notifier/notifierActions';
import sendRequest from '../../../service/sendRequest';

const GET_WRITERS = 'scoutSettings/GET_WRITERS';
const GET_WRITER = 'scoutSettings/GET_WRITER';
const ADD_WRITER = 'scoutSettings/ADD_WRITER';
const EDIT_WRITER = 'scoutSettings/EDIT_WRITER';
const DELETE_WRITER = 'scoutSettings/DELETE_WRITER';

export const getWriters = createAsyncThunk(GET_WRITERS, async (_, { getState }) => {
  const { page, size, sort } = getState().scoutSettings.tableSettings;
  const { language } = getState().scoutSettings.tableFilters;

  const response = await sendRequest(() =>
    callApi.post(`/api/settings/search/writer?page=${page + 1}&size=${size}&sort=${sort}`, {
      ...(language ? { language } : {}),
    }),
  );

  return { content: response.data.content, total: response.data.totalElements };
});

export const getWriter = createAsyncThunk(GET_WRITER, async ({ id }) => {
  const response = await sendRequest(() => callApi.get(`/api/settings/writer/${id}`));

  return response.data;
});

export const addWriter = createAsyncThunk(
  ADD_WRITER,
  async ({ writerColor, writerName, writerPhrase, language }, { dispatch }) => {
    await sendRequest(
      () =>
        callApi.post(`/api/settings/save/writer`, {
          language,
          writerColor,
          writerName,
          writerPhrase,
        }),
      {
        onError: () => {
          dispatch(
            enqueueSnackbar({
              message: 'couldntCreateWriter',
              options: { variant: 'error' },
            }),
          );
        },
      },
    );

    dispatch(
      enqueueSnackbar({
        message: 'writerHasBeenAddedSuccessfully',
        options: {
          variant: 'success',
          messageParams: {
            writerName: name,
          },
        },
      }),
    );
  },
);

export const editWriter = createAsyncThunk(EDIT_WRITER, async ({ id, values }, { dispatch }) => {
  const { writerColor, writerName, writerPhrase, language } = values;

  await sendRequest(
    () =>
      callApi.post(`/api/settings/edit/writer/${id}`, {
        writerColor,
        writerName,
        writerPhrase,
        language,
      }),
    {
      onError: () => {
        dispatch(
          enqueueSnackbar({
            message: 'couldntChangeWriter',
            options: { variant: 'error' },
          }),
        );
      },
    },
  );

  dispatch(
    enqueueSnackbar({
      message: 'writerHasBeenChangedSuccessfully',
      options: {
        variant: 'success',
        messageParams: {
          writerName,
        },
      },
    }),
  );
});

export const deleteWriter = createAsyncThunk(DELETE_WRITER, async ({ id }, { dispatch }) => {
  await sendRequest(() => callApi.delete(`/api/settings/writer/${id}`));

  dispatch(
    enqueueSnackbar({
      message: 'writerHasBeenRemovedSuccessfully',
      options: {
        variant: 'success',
      },
    }),
  );
  dispatch(getWriters());
});
